<template>
  <form @submit.prevent="submitForm()">
    <div class="page-wrap p-3">
      <div class="mt-3 mb-3">
        <a :href="`/eco-payment`">
          <span><i class="fa fa-chevron-left" aria-hidden="true"></i></span>
          Назад
        </a>
      </div>

      <div class="page-header p-3 mb-3 mt-3">
        <h3>Редактирование данных по экологической выплате ({{ defaultTrancheNumber }} квартал {{ defaultTrancheYear }}
          год)</h3>
      </div>
    </div>
    <div class="page-content mt-3 mb-3">

      <div class="card">
        <div class="card-header">
          <h6>Сотрудник</h6>
        </div>
        <div class="card-body">
          <div class="col-md-12">
            <div class="row col-md-9">
              <div class="el-input-group">
                <label class="form-label col-md-3">ИИН</label>
                <div class="col-md-6">
                  <input class="form-control" type="number" required
                         id="iin" v-model="item.employee.iin">
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="row col-md-9">
              <div class="el-input-group">
                <label class="form-label col-md-3">Фамилия</label>
                <div class="col-md-6">
                  <input class="form-control" type="text" id="lastname" required v-model="item.employee.lastname">
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="row col-md-9">
              <div class="el-input-group">
                <label class="form-label col-md-3">Имя</label>
                <div class="col-md-6">
                  <input class="form-control" type="text" id="firstname" required v-model="item.employee.firstname">
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="row col-md-9">
              <div class="el-input-group">
                <label class="form-label col-md-3">Отчество</label>
                <div class="col-md-6">
                  <input class="form-control" type="text" id="patronymic" v-model="item.employee.patronymic">
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="row col-md-9">
              <div class="el-input-group">
                <label class="form-label col-md-3">Должность</label>
                <div class="col-md-6">
                  <input class="form-control" type="text" id="position" required v-model="item.employee.position">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <h6>{{ getMonthName(defaultTrancheNumber, 1) }}</h6>
        </div>
        <div class="card-body">
          <div class="col-md-12">
            <div class="row col-md-12">
              <div class="el-input-group">
                <label class="form-label col-md-4">Должностной оклад</label>
                <div class="col-md-6">
                  <input class="form-control" type="text" required
                         v-model="item.month1.baseSalary">
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="row col-md-12">
              <div class="el-input-group">
                <label class="form-label col-md-4">Ставка</label>
                <div class="col-md-6">
                  <input class="form-control" type="number"
                         min="0" max="2" step="0.25" required
                         v-model="item.month1.rate">
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="row col-md-12">
              <div class="el-input-group">
                <label class="form-label col-md-4">Количество отработанных рабочих дней</label>
                <div class="col-md-6">
                  <input class="form-control" type="number"
                         min="0" max="31" step="1" required
                         v-model="item.month1.workedDays">
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="row col-md-12">
              <div class="el-input-group">
                <label class="form-label col-md-4">Материальная помощь к отпуску</label>
                <div class="col-md-6">
                  <input class="form-control" type="text"
                         v-model="item.month1.vacationAid">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <h6>{{ getMonthName(defaultTrancheNumber, 2) }}</h6>
        </div>
        <div class="card-body">
          <div class="col-md-12">
            <div class="row col-md-12">
              <div class="el-input-group">
                <label class="form-label col-md-4">Должностной оклад</label>
                <div class="col-md-6">
                  <input class="form-control" type="text" required
                         v-model="item.month2.baseSalary">
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="row col-md-12">
              <div class="el-input-group">
                <label class="form-label col-md-4">Ставка</label>
                <div class="col-md-6">
                  <input class="form-control" type="number"
                         min="0" max="2" step="0.25" required
                         v-model="item.month2.rate">
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="row col-md-12">
              <div class="el-input-group">
                <label class="form-label col-md-4">Количество отработанных рабочих дней</label>
                <div class="col-md-6">
                  <input class="form-control" type="number"
                         min="0" max="31" step="1" required
                         v-model="item.month2.workedDays">
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="row col-md-12">
              <div class="el-input-group">
                <label class="form-label col-md-4">Материальная помощь к отпуску</label>
                <div class="col-md-6">
                  <input class="form-control" type="text"
                         v-model="item.month2.vacationAid">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <h6>{{ getMonthName(defaultTrancheNumber, 3) }}</h6>
        </div>
        <div class="card-body">
          <div class="col-md-12">
            <div class="row col-md-12">
              <div class="el-input-group">
                <label class="form-label col-md-4">Должностной оклад</label>
                <div class="col-md-6">
                  <input class="form-control" type="text" required
                         v-model="item.month3.baseSalary">
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="row col-md-12">
              <div class="el-input-group">
                <label class="form-label col-md-4">Ставка</label>
                <div class="col-md-6">
                  <input class="form-control" type="number"
                         min="0" max="2" step="0.25" required
                         v-model="item.month3.rate">
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="row col-md-12">
              <div class="el-input-group">
                <label class="form-label col-md-4">Количество отработанных рабочих дней</label>
                <div class="col-md-6">
                  <input class="form-control" type="number"
                         min="0" max="31" step="1" required
                         v-model="item.month3.workedDays">
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="row col-md-12">
              <div class="el-input-group">
                <label class="form-label col-md-4">Материальная помощь к отпуску</label>
                <div class="col-md-6">
                  <input class="form-control" type="text"
                         v-model="item.month3.vacationAid">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="page-footer justify-content-end">
      <b-button variant="success" type="submit" v-if="hasEditPermission()">
        Сохранить
      </b-button>
    </div>
  </form>

  <vue-loading :active.sync="isLoading" :is-full-page="true"></vue-loading>
</template>

<script>

import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import ecoPaymentService from "@/services/ecoPaymentService";
import {showErrorNotify, showSuccessNotify} from "@/utils/notificationUtils";
import delegationService from "@/services/delegationService";
import settingsService from "@/services/settingsService";

export default {
  components: {
    VueLoading
  },
  computed: {
    ecoPaymentId() {
      return this.$route.params.uuid;
    }
  },
  data() {
    return {
      isLoading: false,
      item: {
        employee: {},
        month1: {},
        month2: {},
        month3: {},
      },
      defaultTrancheYear: null,
      defaultTrancheNumber: null,
    };
  },
  methods: {
    init() {
      this.initSettings().then(response => {
        this.defaultTrancheYear = this.setting.defaultTrancheYear;
        this.defaultTrancheNumber = this.setting.defaultTrancheNumber;

        this.findById(this.ecoPaymentId);
      });
    },
    async findById(ecoPaymentId) {
      this.isLoading = true;
      this.item = await ecoPaymentService.findById(ecoPaymentId);
      this.initDefaultValues();

      this.isLoading = false;
    },
    async submitForm() {
      if (!this.hasEditPermission()) {
        return;
      }

      try {
        this.isLoading = true;

        let isNew = this.item.uuid == null;
        const cleanedItem = this.replaceCommaWithDot(this.item);
        this.item = await ecoPaymentService.save(cleanedItem);

        showSuccessNotify("Успешно сохранено!");
        if (isNew) {
          this.$router.replace('/eco-payment/' + this.item.uuid);
        }
      } catch (exc) {
        showErrorNotify("Возникла ошибка при сохранении");
      } finally {
        this.isLoading = false;
      }
    },
    replaceCommaWithDot(obj) {
      if (typeof obj === 'string') {
        if (/^-?\d+,\d+$/.test(obj)) {
          return obj.replace(',', '.');
        }
        return obj;
      } else if (Array.isArray(obj)) {
        return obj.map(this.replaceCommaWithDot);
      } else if (obj !== null && typeof obj === 'object') {
        const newObj = {};
        for (const key in obj) {
          newObj[key] = this.replaceCommaWithDot(obj[key]);
        }
        return newObj;
      } else {
        return obj;
      }
    },
    isFromUniversity(university) {
      if (this.item == null) {
        return false;
      }
      return this.item.university.universityId === university.id;
    },
    initDefaultValues() {
      if (this.item == null) {
        this.item = {
          uuid: null,
          trancheYear: this.defaultTrancheYear,
          trancheNumber: this.defaultTrancheNumber,
          university: null,
          iin: null,
          lastname: null,
          firstname: null,
          patronymic: null,
          position: null,
          employee: {},
          month1: {
            baseSalary: null,
            rate: null,
            workedDays: null,
            vacationAid: null,
          },
          month2: {
            baseSalary: null,
            rate: null,
            workedDays: null,
            vacationAid: null,
          },
          month3: {
            baseSalary: null,
            rate: null,
            workedDays: null,
            vacationAid: null,
          }
        };
      }

      this.onChange();
    },
    isDisabled() {
      return !this.hasEditPermission();
    },
    onChange() {
    },
    hasEditPermission() {
      return this.isUniversityManager() || this.isAdmin() || this.isManagerFC();
    },
    isAdmin() {
      return delegationService.isAdmin();
    },
    isManagerFC() {
      return delegationService.isManagerFC();
    },
    isUniversityManager() {
      return delegationService.isUniversityManager();
    },
    async initSettings() {
      this.setting = await settingsService.load();
    },
    calcMonthNumber(quarter, monthInQuarter) {
      return (quarter - 1) * 3 + monthInQuarter;
    },
    getMonthName(quarter, monthInQuarter) {
      if (!quarter) {
        return "";
      }

      const monthNumber = this.calcMonthNumber(quarter, monthInQuarter);

      const monthNames = [
        "Январь", "Февраль", "Март",
        "Апрель", "Май", "Июнь",
        "Июль", "Август", "Сентябрь",
        "Октябрь", "Ноябрь", "Декабрь"
      ];

      if (monthNumber < 1 || monthNumber > 12) {
        throw new Error("Некорректный номер квартала или месяца");
      }

      return monthNames[monthNumber - 1];
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style scoped>
.row {
  padding-top: 5px;
}

.card {
  margin-bottom: 15px;
}

.p-3 {
  padding: 0.1rem !important;
}
</style>
